import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  isLoading?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  isLoading = false,
  fullWidth = false,
  className = '',
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-lg font-medium transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed text-sm px-5 py-3';
  const variants = {
    primary: 'bg-[#FFD700] text-gray-900 hover:bg-[#FFC700] focus:ring-[#FFD700] shadow-sm font-semibold',
    secondary: 'bg-gray-900 text-white hover:bg-gray-800 focus:ring-gray-900 shadow-sm',
    outline: 'border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:ring-[#FFD700]',
    ghost: 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-504">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-505" />}
      {children}
    </button>;
}